import {
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { ROLE_COLLECTION_ID } from './role';
import { getAllDocuments } from '../documents/document.selectors';
import {
  getAuthorisationRoles,
  getAuthorisationScopes,
} from '../config/config.selectors';
import { Role } from '@digitaix/types';

export const getAllRoles: MemoizedSelector<any, Role[]> = createSelector(
  getAllDocuments<Role>(ROLE_COLLECTION_ID),
  (roles) => roles,
);

export const getAllRolesAsOptions: MemoizedSelector<any, any> = createSelector(
  getAllRoles,
  getAuthorisationRoles,
  (roles, defaultRoles) => {
    roles = [ ...roles, ...defaultRoles ].filter((role, index, self) => self.findIndex(r => r.id === role.id) === index);
    return roles.map(role => ({ value: role.id, display: role.name }));
  }
);

export const getPermissionScopesAsOptions = createSelector(
  getAuthorisationScopes,
  scopes => Object.entries(scopes).map(([value, display]) => ({ value, display }))
);
